export default __webpack_public_path__ + "static/media/cardinalhealth.7ef051e7.png";